var ProjectList = require("src/client-ts/containers/Projects/ProjectList");

exports.newProjectList = ProjectList.ProjectList;
